import { render, staticRenderFns } from "./previsional-budget.vue?vue&type=template&id=d0c812e0&"
import script from "./previsional-budget.vue?vue&type=script&lang=ts&"
export * from "./previsional-budget.vue?vue&type=script&lang=ts&"
import style0 from "./previsional-budget.vue?vue&type=style&index=0&id=d0c812e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports